






























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { userManagementServe } from '@/api/installServer';

@Component({
  components: {},
})
export default class AddUser extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象
  private title: any = ''; // dialog 标题
  private type: any = ''; // 触发弹框方式
  scrollbar = true;

  // 表单数据
  private formData: any = {
    admin: false,
    email: '',
    mobile: '',
    id: '',
    nickname: '',
    password: '',
    username: '',
  };
  // 表单验证规则
  formRules: object = {
    username: [
      { required: true, message: '请输入用户名', trigger: 'blur' },
      { max: 16, message: '长度最大为16个字符', trigger: 'blur' },
      // {validator: this.validateAccount, trigger: 'blur'},
    ],
    nickname: [
      { required: true, message: '请输入昵称', trigger: 'blur' },
      { max: 16, message: '长度最大为16个字符', trigger: 'blur' },
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      { max: 32, message: '长度最大为32个字符', trigger: 'blur' },
      { validator: this.validatePassword, trigger: 'blur' },
    ],
    mobile: [
      { required: false, message: '请输入手机号码', trigger: 'blur' },
      { pattern: /^1[34578]\d{9}$/, message: '手机号码格式不正确' },
      // {validator: this.validatePhone, trigger: 'blur'},
    ],
    email: [
      { required: false, message: '请输入邮箱', trigger: 'blur' },
      { max: 32, message: '长度最大为32个字符', trigger: 'blur' },
      {
        pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
        message: '邮箱格式不正确',
      },
      // {validator: this.validateMail, trigger: 'blur'},
    ],
  };

  created() {
    if (this.row.id) {
      this.type = 'edit';
      this.title = '编辑用户';
      this.formData = this.row;
    } else {
      this.type = 'add';
      this.title = '新增用户';
      this.formData = this.row;
    }
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 保存并提交编辑、新增
   * @param1 暂无
   * @returns 暂无
   */
  save(): void {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      switch (this.type) {
        case 'add':
          this.addFunctionData();
          break;
        case 'edit':
          this.editFunctionData();
          break;
      }
    });
  }

  /**
   * 【接口】新增功能
   */
  private async addFunctionData() {
    userManagementServe
      .addUserData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功');
          this.close(); // 返回到父级页面
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('添加失败,请稍后重试!');
      });
  }

  /**
   * 【接口】编辑功能
   */
  private async editFunctionData() {
    userManagementServe
      .editUserData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('保存成功');
          this.close(); // 返回到父级页面
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {});
  }

  /**
   * 【验证】验证用户账号
   * @Params
   * @return
   **/
  // private async validateAccount(rule: any, value: any, callback: any) {
  //     const usernameReg = /^.{1,20}$/g;
  //     if (!usernameReg.test(value)) {
  //         callback(new Error('账号应由1到20个字符组成'));
  //     }
  //     const res: any = await user.checkData({username: value});
  //     switch (res.code) {
  //         case 20001:
  //             callback();
  //             break;
  //         case 20002:
  //             callback(new Error('该账号已存在'));
  //             break;
  //     }
  // }

  /**
   * 【验证】验证用户密码
   * @Params
   * @return
   **/
  private async validatePassword(rule: any, value: any, callback: any) {
    const passwordReg = /^.{6,20}$/g;
    if (!passwordReg.test(value)) {
      callback(new Error('密码应由6到20个字符组成'));
    }
    callback();
  }

  /**
   * 【验证】验证用户手机号码
   * @Params
   * @return
   **/
  // private async validatePhone(rule: any, value: any, callback: any) {
  //     if (value === '') {
  //         callback();
  //     } else {
  //         const res: any = await user.checkData({mobile: value});
  //         switch (res.code) {
  //             case 20001:
  //                 callback();
  //                 break;
  //             case 20002:
  //                 callback(new Error('该手机号已存在'));
  //                 break;
  //         }
  //     }
  // }

  /**
   * 【验证】验证用户邮箱
   * @Params
   * @return
   **/
  // private async validateMail(rule: any, value: any, callback: any) {
  //     if (value === '') {
  //         callback();
  //     } else {
  //         const res: any = await user.checkData({email: value});
  //         switch (res.code) {
  //             case 20001:
  //                 callback();
  //                 break;
  //             case 20002:
  //                 callback(new Error('该邮箱已存在'));
  //                 break;
  //         }
  //     }
  // }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.formData = {
      admin: false,
      email: '',
      mobile: '',
      id: '',
      nickname: '',
      password: '',
      username: '',
    };
    this.$emit('on-response');
  }
}
